import gql from "graphql-tag";
import api from "../apiClient";

export default {
  list: () =>
    api
      .send({
        query: gql`
          query moneda {
            TYPES {
              Moneda {
                readCountry {
                  id
                  value
                  pais
                  simbolo
                }
              }
            }
          }
        `,
      })
      .then((result) => result.data.data.TYPES.Moneda.readCountry),
};
